// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"144ee3e4","488":"7e4a3582","977":"9771ce46"}[chunkId] + ".chunk.js";
};